// Mock data for Fit Pro Meals - Dallas/Fort Worth Meal Prep Delivery Service

export const SITE_CONFIG = {
  name: "Fit Pro Meals",
  tagline: "Freshly Prepared Meals Delivered to Your Door",
  phone: "(214) 876-1653",
  email: "hello@dfwfitmeals.com",
  address: "Fort Worth, TX 76101",
  serviceArea: "Tarrant County, Dallas County, Plano & Frisco",
  orderDeadline: "Thursday by 1:00 PM",
  deliveryDay: "Sunday",
  deliveryTime: "Early afternoon",
  minimumMeals: 8,
  deliveryFee: 15,
  instagram: "https://www.instagram.com/fitpmeals/",
  facebook: "https://www.facebook.com/profile.php?id=100089894090852",
  domain: "https://dfwfitmeals.com",
  logoUrl: "/logo.png",
};

export const WEEKLY_MENU = [
  {
    id: 1,
    slug: "orange-chicken",
    name: "Orange Chicken",
    price: 12.50,
    image: "https://images.unsplash.com/photo-1705596704813-b39b95549cd2?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1705596704813-b39b95549cd2?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1636401870585-a8852371e84a?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1687966699414-095ca9c35593?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Chicken Thighs tossed in a Sugar Free Asian Orange Sauce w/ Jasmine Rice & Broccoli.",
    fullDescription: "Tender chicken thighs slow-braised in our house-made sugar-free Asian orange sauce, served over fluffy jasmine rice with perfectly steamed broccoli. A fan-favorite that delivers bold flavor without the sugar crash.",
    note: "Sauce medium spice level.",
    ingredients: ["Chicken Thighs", "Jasmine Rice", "Broccoli", "Sugar-Free Orange Sauce (Orange Zest, Tamari, Monk Fruit, Ginger, Garlic)", "Sesame Seeds"],
    allergens: ["Soy", "Sesame"],
    prepTime: "3 minutes (microwave)",
    servingSize: "1 container (approx. 380g)",
    calories: 416, fats: 8, carbs: 55, protein: 30,
    category: "Lunch/Dinner",
    badge: "Popular",
    tags: ["High Protein", "Low Fat", "Sugar Free"],
    available: true,
    rating: 4.9, reviewCount: 47,
  },
  {
    id: 2,
    slug: "shredded-beef-tacos",
    name: "Shredded Beef Tacos",
    price: 13.50,
    image: "https://images.unsplash.com/photo-1543353071-c953d88f7033?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1543353071-c953d88f7033?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Shredded Beef, (3) Zero Carb Tortillas, Onions, Cilantro & Avocado Salsa.",
    fullDescription: "Slow-braised, fork-tender shredded beef packed into 3 zero-carb tortillas, topped with diced white onion, fresh cilantro, and our house avocado salsa verde. Perfect for keto and low-carb lifestyles without sacrificing flavor.",
    note: "",
    ingredients: ["Braised Beef Chuck", "Zero-Carb Mission Tortillas (3)", "White Onion", "Fresh Cilantro", "Avocado Salsa Verde", "Lime"],
    allergens: ["Wheat (tortillas)"],
    prepTime: "2 minutes (microwave)",
    servingSize: "1 container (approx. 340g)",
    calories: 326, fats: 17, carbs: 4, protein: 28,
    category: "Lunch/Dinner",
    badge: "Low Carb",
    tags: ["Low Carb", "Keto-Friendly", "High Protein"],
    available: true,
    rating: 4.8, reviewCount: 38,
  },
  {
    id: 3,
    slug: "chicken-cobb-salad",
    name: "Chicken Cobb Salad",
    price: 11.50,
    image: "https://images.unsplash.com/photo-1597958792579-bd3517df6399?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1597958792579-bd3517df6399?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Grilled Garlic & Herb Chicken, Spring Mix, Egg, Bacon, Tomatoes & Feta. Served with a Low-Fat Ranch.",
    fullDescription: "Juicy garlic and herb-marinated grilled chicken breast over a bed of crisp spring mix with hard-boiled egg, nitrate-free bacon crumbles, cherry tomatoes, and crumbled feta cheese. Paired with our low-fat house ranch dressing.",
    note: "Ranch: 100 Cal | 8F | 6C | 1P",
    ingredients: ["Grilled Chicken Breast", "Spring Mix", "Hard-Boiled Egg", "Turkey Bacon", "Cherry Tomatoes", "Feta Cheese", "Low-Fat Ranch (side)"],
    allergens: ["Eggs", "Dairy", "Pork"],
    prepTime: "Ready to eat (no heating needed)",
    servingSize: "1 container (approx. 300g)",
    calories: 225, fats: 8, carbs: 4, protein: 30,
    category: "Lunch/Dinner",
    badge: "Low Cal",
    tags: ["Low Calorie", "High Protein", "Low Carb", "Keto-Friendly"],
    available: true,
    rating: 4.7, reviewCount: 29,
  },
  {
    id: 4,
    slug: "vodka-tortellini",
    name: "Vodka Tortellini",
    price: 12.50,
    image: "https://images.unsplash.com/photo-1771384552858-feb0574f958d?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1771384552858-feb0574f958d?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Tortellini filled with Cheese, Lean Italian Ground Turkey & a Creamy Vodka Sauce.",
    fullDescription: "Stuffed cheese tortellini tossed with lean Italian-seasoned ground turkey in a velvety creamy vodka tomato sauce. A high-protein comfort food classic made clean — no heavy cream, just rich flavor.",
    note: "",
    ingredients: ["Cheese Tortellini", "Lean Ground Turkey", "Vodka Tomato Sauce (San Marzano Tomatoes, Light Cream, Vodka, Basil)", "Parmesan", "Fresh Basil"],
    allergens: ["Wheat", "Dairy", "Eggs"],
    prepTime: "3 minutes (microwave)",
    servingSize: "1 container (approx. 420g)",
    calories: 487, fats: 12, carbs: 51, protein: 35,
    category: "Lunch/Dinner",
    badge: "High Protein",
    tags: ["High Protein", "Comfort Food"],
    available: true,
    rating: 4.9, reviewCount: 52,
  },
  {
    id: 5,
    slug: "lemon-pepper-chicken",
    name: "Lemon Pepper Chicken",
    price: 11.50,
    image: "https://images.unsplash.com/photo-1666819691822-29a09f0992e5?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1666819691822-29a09f0992e5?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1762631383588-7c9df7e91e64?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Grilled Lemon Pepper Chicken Breast, Quinoa, Roasted Vegetables & Parmesan Garlic Dipping Sauce.",
    fullDescription: "Zesty lemon-pepper marinated chicken breast grilled to perfection, served over protein-packed quinoa with colorful oven-roasted seasonal vegetables. Includes a side of creamy parmesan garlic dipping sauce.",
    note: "Sauce: 90 Cal | 9F | 1C | 0P",
    ingredients: ["Chicken Breast", "Quinoa", "Roasted Zucchini", "Roasted Red Bell Pepper", "Roasted Broccoli", "Lemon Pepper Marinade", "Parmesan Garlic Sauce (side)"],
    allergens: ["Dairy"],
    prepTime: "3 minutes (microwave)",
    servingSize: "1 container (approx. 360g)",
    calories: 280, fats: 5, carbs: 23, protein: 30,
    category: "Lunch/Dinner",
    badge: "",
    tags: ["High Protein", "Low Fat", "Low Calorie"],
    available: true,
    rating: 4.8, reviewCount: 33,
  },
  {
    id: 6,
    slug: "southwest-sweet-potato",
    name: "Southwest Sweet Potato",
    price: 12.50,
    image: "https://images.unsplash.com/photo-1569420077790-afb136b3bb8c?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1569420077790-afb136b3bb8c?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1567575990843-105a1c70d76e?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Sweet Potato Mash, Lean Seasoned Ground Beef, Corn, Black Beans & Pico de Gallo served w/ Creamy Low Fat Ranch.",
    fullDescription: "Velvety roasted sweet potato mash topped with lean Southwest-spiced ground beef, fire-roasted corn, black beans, and fresh pico de gallo. Served with our light ranch dressing on the side.",
    note: "Ranch: 100 Cal | 7.5F | 6C | 1P",
    ingredients: ["Sweet Potato Mash", "Lean Ground Beef 90/10", "Fire-Roasted Corn", "Black Beans", "Pico de Gallo (Tomato, Onion, Jalapeño, Cilantro)", "Low-Fat Ranch (side)"],
    allergens: ["Dairy"],
    prepTime: "3 minutes (microwave)",
    servingSize: "1 container (approx. 400g)",
    calories: 350, fats: 12, carbs: 34, protein: 27,
    category: "Lunch/Dinner",
    badge: "",
    tags: ["Balanced Macros", "High Protein"],
    available: true,
    rating: 4.7, reviewCount: 24,
  },
  {
    id: 7,
    slug: "thai-basil-chicken",
    name: "Thai Basil Chicken",
    price: 11.50,
    image: "https://images.unsplash.com/photo-1771074168439-0083aaac48e7?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1771074168439-0083aaac48e7?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1705596704813-b39b95549cd2?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Ground Chicken with Basil, Thai Chilis & Jasmine Rice & a Sweet Spicy Thai Sauce (Sweetened with Stevia).",
    fullDescription: "Authentic pad krapow-inspired ground chicken stir-fried with fresh Thai basil, bird's eye chilis, and aromatic garlic over steamed jasmine rice. Sauce sweetened with stevia — all the flavor, none of the sugar spike.",
    note: "Medium spice level",
    ingredients: ["Ground Chicken", "Fresh Thai Basil", "Bird's Eye Chilis", "Garlic", "Jasmine Rice", "Thai Sweet Chili Sauce (Stevia-sweetened)", "Oyster Sauce"],
    allergens: ["Soy", "Shellfish (Oyster sauce)"],
    prepTime: "3 minutes (microwave)",
    servingSize: "1 container (approx. 370g)",
    calories: 394, fats: 9, carbs: 48, protein: 28,
    category: "Lunch/Dinner",
    badge: "New",
    tags: ["High Protein", "Spicy", "Sugar Free"],
    available: true,
    rating: 4.8, reviewCount: 19,
  },
  {
    id: 8,
    slug: "egg-white-bites",
    name: "Egg White Bites",
    price: 8.00,
    image: "https://images.unsplash.com/photo-1562571708-527276a391ac?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1562571708-527276a391ac?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1610441009633-b6ca9c6d4be2?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Egg Whites, Turkey Sausage & Pico de Gallo. Served w/ Guacamole Salsa.",
    fullDescription: "Light, fluffy egg white bites loaded with crumbled turkey sausage and vibrant pico de gallo, baked to perfection. Served alongside our fresh guacamole salsa for a protein-packed, ultra-low-carb breakfast.",
    note: "Guacamole Salsa: 50 Cal | 4.5F | 2C | 0P",
    ingredients: ["Liquid Egg Whites", "Turkey Sausage (No Nitrates)", "Pico de Gallo (Fresh)", "Guacamole Salsa (Avocado, Lime, Jalapeño)", "Chives"],
    allergens: ["Eggs"],
    prepTime: "90 seconds (microwave)",
    servingSize: "1 container (3 bites + salsa)",
    calories: 208, fats: 8, carbs: 2, protein: 30,
    category: "Breakfast",
    badge: "Best Value",
    tags: ["Low Calorie", "High Protein", "Low Carb", "Keto-Friendly", "Breakfast"],
    available: true,
    rating: 4.9, reviewCount: 61,
  },
  {
    id: 9,
    slug: "birthday-cake-protein-pancakes",
    name: "Birthday Cake Protein Pancakes",
    price: 10.00,
    image: "https://images.unsplash.com/photo-1757635964104-67218db55bca?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1757635964104-67218db55bca?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1694458557352-4b8ca744dea7?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "3 Fluffy Birthday Cake Protein Pancakes & 1 Turkey Sausage Patty with Sugar Free Maple Syrup.",
    fullDescription: "Three tall, fluffy birthday cake-flavored protein pancakes made from scratch with oat flour, whey protein, and stevia — served with one turkey sausage patty and a side of sugar-free maple syrup. Indulge without the guilt.",
    note: "Made with Oat Flour, Milk, Egg, Stevia & Protein Powder",
    ingredients: ["Oat Flour", "Whey Protein Powder", "Egg", "Milk", "Stevia", "Birthday Cake Extract", "Turkey Sausage Patty (1)", "Sugar-Free Maple Syrup (side)"],
    allergens: ["Wheat", "Eggs", "Dairy"],
    prepTime: "2 minutes (microwave)",
    servingSize: "1 container (3 pancakes + 1 sausage patty)",
    calories: 375, fats: 10, carbs: 47, protein: 28,
    category: "Breakfast",
    badge: "",
    tags: ["High Protein", "Breakfast", "Low Sugar"],
    available: true,
    rating: 4.8, reviewCount: 43,
  },
  {
    id: 10,
    slug: "custom-meal",
    name: "Custom Meal",
    price: 12.50,
    image: "https://images.unsplash.com/photo-1543352632-fea6d4f83e78?fm=jpg&q=80&w=800&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1543352632-fea6d4f83e78?fm=jpg&q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1569420077790-afb136b3bb8c?fm=jpg&q=80&w=800&auto=format&fit=crop",
    ],
    description: "Customize your own meal to meet your macros. Choose your protein, carb & veggie.",
    fullDescription: "Build your perfect meal from scratch. Select your protein source, complex carbohydrate, and vegetable. Prepared plain — no seasonings or oils — giving you complete macro control. Perfect for athletes with precise dietary targets.",
    note: "No seasonings or oils",
    ingredients: ["Your choice of protein", "Your choice of carb", "Your choice of veggie"],
    allergens: ["Depends on selection"],
    prepTime: "2-3 minutes (microwave)",
    servingSize: "1 container (Protein 5oz, Carb ½ cup, Veggie 1 cup)",
    calories: null, fats: null, carbs: null, protein: null,
    category: "Custom",
    badge: "Custom",
    tags: ["Customizable", "Any Diet"],
    available: true,
    isCustom: true,
    rating: 4.7, reviewCount: 28,
    customOptions: {
      proteins: [
        { name: "Grilled Chicken Breast", macros: "165 Cal / 5F / 0C / 30P" },
        { name: "Grilled Chicken Thighs", macros: "190 Cal / 12F / 0C / 28P" },
        { name: "Lean Ground Beef 90/10", macros: "238 Cal / 12F / 0C / 28P" },
        { name: "Lean Ground Turkey", macros: "200 Cal / 10F / 0C / 26P" },
      ],
      carbs: [
        { name: "Jasmine Rice", macros: "103 Cal / 0.2F / 22C / 2P" },
        { name: "Quinoa", macros: "120 Cal / 2F / 21C / 4P" },
        { name: "Sweet Potato", macros: "60 Cal / 0F / 13C / 1P" },
        { name: "Double Carb (no veggie)", macros: "×2 carb macros" },
      ],
      veggies: [
        { name: "Steamed Broccoli", macros: "31 Cal / 0F / 6C / 2P" },
        { name: "Steamed Green Beans", macros: "35 Cal / 0F / 8C / 2P" },
        { name: "Roasted Squash & Zucchini", macros: "40 Cal / 1F / 7C / 2P" },
        { name: "Double Veggie (no carb)", macros: "×2 veggie macros" },
      ],
    },
  },
];

// Subscription Plans
export const SUBSCRIPTION_PLANS = [
  {
    id: "starter-weekly",
    name: "Starter",
    meals: 8,
    frequency: "weekly",
    frequencyLabel: "Every Sunday",
    pricePerMeal: 11.50,
    subtotal: 92.00,
    delivery: 15.00,
    total: 107.00,
    savings: 0,
    savingsPct: 0,
    popular: false,
    description: "Perfect for starting your healthy eating journey.",
    perks: ["8 freshly prepared meals", "Free delivery every Sunday", "Cancel or pause anytime", "Macro info on every meal"],
    packageKey: "starter-weekly",
  },
  {
    id: "popular-weekly",
    name: "Weekly Fuel",
    meals: 12,
    frequency: "weekly",
    frequencyLabel: "Every Sunday",
    pricePerMeal: 11.00,
    subtotal: 132.00,
    delivery: 15.00,
    total: 147.00,
    savings: 6.00,
    savingsPct: 4,
    popular: true,
    description: "Most popular — a full week of clean eating covered.",
    perks: ["12 freshly prepared meals", "Free delivery every Sunday", "Priority order processing", "Cancel or pause anytime", "Macro info on every meal"],
    packageKey: "popular-weekly",
  },
  {
    id: "performance-weekly",
    name: "Performance",
    meals: 16,
    frequency: "weekly",
    frequencyLabel: "Every Sunday",
    pricePerMeal: 11.25,
    subtotal: 180.00,
    delivery: 15.00,
    total: 195.00,
    savings: 16.00,
    savingsPct: 8,
    popular: false,
    description: "For serious athletes fueling peak performance.",
    perks: ["16 freshly prepared meals", "Free delivery every Sunday", "Priority order processing", "Custom macro consultation", "Cancel or pause anytime"],
    packageKey: "performance-weekly",
  },
  {
    id: "starter-biweekly",
    name: "Starter",
    meals: 8,
    frequency: "biweekly",
    frequencyLabel: "Every 2 Weeks",
    pricePerMeal: 11.50,
    subtotal: 92.00,
    delivery: 15.00,
    total: 107.00,
    savings: 0,
    savingsPct: 0,
    popular: false,
    description: "Healthy meals every other week — great starter plan.",
    perks: ["8 freshly prepared meals", "Delivery every 2 weeks", "Cancel or pause anytime", "Macro info on every meal"],
    packageKey: "starter-biweekly",
  },
  {
    id: "popular-biweekly",
    name: "Bi-Weekly Fuel",
    meals: 12,
    frequency: "biweekly",
    frequencyLabel: "Every 2 Weeks",
    pricePerMeal: 11.00,
    subtotal: 132.00,
    delivery: 15.00,
    total: 147.00,
    savings: 6.00,
    savingsPct: 4,
    popular: false,
    description: "12 meals every other Sunday — perfect balance.",
    perks: ["12 freshly prepared meals", "Delivery every 2 weeks", "Priority order processing", "Cancel or pause anytime"],
    packageKey: "popular-biweekly",
  },
  {
    id: "performance-biweekly",
    name: "Bi-Weekly Performance",
    meals: 16,
    frequency: "biweekly",
    frequencyLabel: "Every 2 Weeks",
    pricePerMeal: 11.25,
    subtotal: 180.00,
    delivery: 15.00,
    total: 195.00,
    savings: 16.00,
    savingsPct: 8,
    popular: false,
    description: "Maximum meals, every other Sunday delivery.",
    perks: ["16 freshly prepared meals", "Delivery every 2 weeks", "Priority order processing", "Cancel or pause anytime"],
    packageKey: "performance-biweekly",
  },
];

// Instagram-style social feed
export const SOCIAL_FEED = [
  { id: 1, image: "https://images.unsplash.com/photo-1705596704813-b39b95549cd2?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Orange Chicken with jasmine rice 🍊🔥 Sugar-free sauce, 416 cal, 30g protein. Order by Thursday! #FitProMeals #MealPrep #DFW", likes: 127, comments: 14, type: "meal" },
  { id: 2, image: "https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Sunday deliveries are happening! Who's getting their meals today? 🚚💚 #SundayMealPrep #FitProMeals #FortWorth", likes: 203, comments: 31, type: "delivery" },
  { id: 3, image: "https://images.unsplash.com/photo-1666819691822-29a09f0992e5?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Lemon Pepper Chicken on quinoa ✅ 280 cal | 30g protein | 5g fat. Clean eating made EASY. #HighProtein #CleanEating", likes: 89, comments: 8, type: "meal" },
  { id: 4, image: "https://images.unsplash.com/photo-1597958792579-bd3517df6399?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Chicken Cobb Salad 🥗 Only 225 calories & 30g protein. Low cal, high protein king. #MealPrepDFW #PlanoTX", likes: 156, comments: 22, type: "meal" },
  { id: 5, image: "https://images.unsplash.com/photo-1757635964104-67218db55bca?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Birthday Cake Protein Pancakes 🥞 28g protein and tastes like dessert. Order yours! #FitProMeals", likes: 312, comments: 47, type: "lifestyle" },
  { id: 6, image: "https://images.unsplash.com/photo-1543352632-fea6d4f83e78?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Meal prep Sunday done right 💚 Who else is starting their week strong? #FortWorthFood #DFWEats", likes: 178, comments: 19, type: "meal" },
  { id: 7, image: "https://images.unsplash.com/photo-1543353071-c953d88f7033?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Shredded Beef Tacos 🌮 Zero carb tortillas, 326 cal, 28g protein. KETO FRIENDLY! #KetoMeals #FriscoTX", likes: 244, comments: 38, type: "meal" },
  { id: 8, image: "https://images.unsplash.com/photo-1562571708-527276a391ac?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Egg White Bites 🥚 Only $8! Best value on the menu. 208 cal | 30g protein. #Breakfast #MealPrepSunday", likes: 195, comments: 27, type: "meal" },
  { id: 9, image: "https://images.unsplash.com/photo-1569420077790-afb136b3bb8c?fm=jpg&q=80&w=400&auto=format&fit=crop", caption: "Week 8 and still going strong 💪 Ordered 12 meals and saved SO much time this week. Thank you @fitpmeals! 🙌", likes: 431, comments: 62, type: "testimonial" },
];

// DFW Cities for SEO landing pages
export const DFW_CITIES = [
  { slug: "fort-worth", name: "Fort Worth", state: "TX", county: "Tarrant County", population: "918,915", description: "Serving Fort Worth and all of Tarrant County with fresh, chef-crafted meal prep delivery every Sunday.", neighborhoods: ["Southlake", "Keller", "Hurst", "Euless", "Bedford", "Grapevine", "Colleyville"], heroImage: "https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Fort Worth's health-conscious community is growing — join 200+ local families fueling their week with Fit Pro Meals." },
  { slug: "dallas", name: "Dallas", state: "TX", county: "Dallas County", population: "1,288,457", description: "Fresh, healthy meal prep delivered to Dallas neighborhoods every Sunday. Chef-crafted, macro-tracked, never frozen.", neighborhoods: ["Uptown", "Oak Lawn", "Bishop Arts", "Lake Highlands", "Preston Hollow", "Deep Ellum"], heroImage: "https://images.unsplash.com/photo-1705596704813-b39b95549cd2?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Dallas professionals save 10+ hours per week by letting Fit Pro Meals handle their meal prep." },
  { slug: "plano", name: "Plano", state: "TX", county: "Collin County", population: "285,494", description: "Meal prep delivery to Plano, TX. Healthy, chef-crafted meals dropped at your door every Sunday morning.", neighborhoods: ["Legacy West", "West Plano", "East Plano", "Willow Bend", "Gleneagles"], heroImage: "https://images.unsplash.com/photo-1666819691822-29a09f0992e5?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Plano is one of the healthiest cities in Texas — Fit Pro Meals helps busy Plano families eat clean without the effort." },
  { slug: "frisco", name: "Frisco", state: "TX", county: "Collin County", population: "200,509", description: "Healthy meal prep delivery in Frisco, TX. Fresh meals every Sunday — perfect for Frisco's active families and athletes.", neighborhoods: ["The Star", "Wade Park", "Stonebriar", "Lexington", "Phillips Creek Ranch"], heroImage: "https://images.unsplash.com/photo-1597958792579-bd3517df6399?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Frisco is one of the fastest-growing cities in America — Fit Pro Meals keeps up with your active Frisco lifestyle." },
  { slug: "arlington", name: "Arlington", state: "TX", county: "Tarrant County", population: "394,266", description: "Fresh meal prep delivery in Arlington, TX. Healthy, macro-tracked meals delivered to your Arlington door every Sunday.", neighborhoods: ["Entertainment District", "North Arlington", "South Arlington", "Mansfield"], heroImage: "https://images.unsplash.com/photo-1757635964104-67218db55bca?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Arlington families love the convenience of Fit Pro Meals — fresh food, no cooking, no cleanup." },
  { slug: "irving", name: "Irving", state: "TX", county: "Dallas County", population: "238,289", description: "Healthy meal prep delivery to Irving, TX. Freshly prepared, macro-tracked meals every Sunday.", neighborhoods: ["Las Colinas", "Valley Ranch", "MacArthur Park", "Hackberry Creek"], heroImage: "https://images.unsplash.com/photo-1543353071-c953d88f7033?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Las Colinas professionals trust Fit Pro Meals to keep their nutrition on track during busy work weeks." },
  { slug: "garland", name: "Garland", state: "TX", county: "Dallas County", population: "234,943", description: "Meal prep delivery in Garland, TX. Chef-crafted, healthy meals delivered fresh every Sunday.", neighborhoods: ["Sachse", "Rowlett", "Duck Creek", "Firewheel", "North Garland"], heroImage: "https://images.unsplash.com/photo-1543352632-fea6d4f83e78?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Garland residents save time and money by choosing Fit Pro Meals over expensive takeout." },
  { slug: "grand-prairie", name: "Grand Prairie", state: "TX", county: "Dallas/Tarrant County", population: "193,561", description: "Fresh, healthy meal prep delivered to Grand Prairie, TX every Sunday. Minimum 8 meals, $15 flat delivery.", neighborhoods: ["Dalworth Park", "South Grand Prairie", "Lynn Creek", "Epic Waters"], heroImage: "https://images.unsplash.com/photo-1562571708-527276a391ac?fm=jpg&q=75&w=1200&auto=format&fit=crop", localFact: "Grand Prairie families love starting the week right with Fit Pro Meals every Sunday." },
];

export const TESTIMONIALS = [
  { id: 1, name: "Sarah M.", location: "Fort Worth, TX", rating: 5, text: "Fit Pro Meals completely changed how I eat. I lost 18 pounds in 2 months and I never feel deprived. The Orange Chicken is honestly better than any restaurant!", achievement: "Lost 18 lbs in 2 months", avatar: "SM", weeks: 8 },
  { id: 2, name: "James R.", location: "Dallas, TX", rating: 5, text: "As a busy professional, I used to skip meals or hit drive-throughs. Now I have perfectly portioned, macro-tracked meals ready to go. My energy is through the roof.", achievement: "Gained 8 lbs of muscle", avatar: "JR", weeks: 12 },
  { id: 3, name: "Amanda K.", location: "Plano, TX", rating: 5, text: "The variety is incredible — every week I look forward to seeing the new menu. The food tastes amazing and I'm hitting my macros effortlessly. Worth every penny!", achievement: "Lost 12 lbs in 6 weeks", avatar: "AK", weeks: 6 },
  { id: 4, name: "Marcus T.", location: "Frisco, TX", rating: 5, text: "I've tried three different meal prep services. Fit Pro Meals is hands down the best — the food actually tastes good and the macros are exactly what I need for my training.", achievement: "Down 2 pant sizes", avatar: "MT", weeks: 16 },
  { id: 5, name: "Lisa C.", location: "Arlington, TX", rating: 5, text: "The Shredded Beef Tacos are absolutely incredible. Sunday delivery is so convenient — I set up my whole week with just one order. My family loves them too!", achievement: "Lost 22 lbs", avatar: "LC", weeks: 20 },
  { id: 6, name: "David H.", location: "Irving, TX", rating: 5, text: "I was skeptical at first but the food quality blew me away. Fresh, clean ingredients, great macros, and it actually tastes like real food — not diet food.", achievement: "Lowered body fat 8%", avatar: "DH", weeks: 24 },
];

export const HOW_IT_WORKS = [
  { step: 1, title: "Browse the Weekly Menu", description: "Every week features a rotating menu of chef-crafted meals. Browse options, check macros, and pick your favorites by Thursday at 1 PM." },
  { step: 2, title: "Place Your Order", description: "Select a minimum of 8 meals, fill out the order form, and secure your delivery slot. We deliver to DFW, Plano & Frisco on Sundays." },
  { step: 3, title: "Sunday Delivery", description: "Fresh meals arrive at your door Sunday afternoon. Heat, eat, and fuel your week — no shopping, no cooking, no cleanup." },
];

export const FAQ_ITEMS = [
  { question: "What is the minimum order?", answer: "The minimum order is 8 meals per delivery. This ensures we can provide the freshest ingredients at the best price while keeping delivery efficient for our DFW customers." },
  { question: "When is the order deadline?", answer: "All orders must be placed by Thursday at 1:00 PM to be included in that weekend's Sunday delivery." },
  { question: "Where do you deliver?", answer: "We deliver throughout Tarrant County, Dallas County, Plano, and Frisco. Contact us if you're outside these areas." },
  { question: "How long do the meals last?", answer: "Our freshly prepared meals stay good for 5-7 days when stored properly in the refrigerator." },
  { question: "How do I heat the meals?", answer: "Most meals reheat in 2-3 minutes in the microwave. Heating instructions are included with every order." },
  { question: "Can I customize my meals?", answer: "Yes! We offer a Custom Meal option at $12.50 where you can choose your protein (5oz), carb (1/2 cup), and veggie." },
  { question: "Can I cancel my subscription?", answer: "Yes — cancel or pause your subscription anytime, no questions asked. Just contact us before Thursday 1 PM to skip the next delivery." },
  { question: "How does billing work for subscriptions?", answer: "You're billed each week (or every 2 weeks for bi-weekly plans) before your delivery Sunday. Cancel anytime." },
];

export const BENEFITS = [
  { title: "Chef-Crafted Recipes", description: "Every meal is created by our culinary team using restaurant-quality techniques and fresh, whole ingredients." },
  { title: "Macro-Tracked", description: "Every meal comes with exact calorie, protein, carb, and fat counts so you can hit your fitness goals with confidence." },
  { title: "Save 10+ Hours/Week", description: "No grocery shopping, no cooking, no meal prep. Just open, heat, and eat — giving you back your time." },
  { title: "Fresh, Never Frozen", description: "We prepare every meal fresh each week. No preservatives, no additives — just real food made with quality ingredients." },
  { title: "Local DFW Business", description: "We're your neighbors! Proudly serving the Dallas-Fort Worth metroplex with locally inspired, fresh meals every week." },
  { title: "Rotating Weekly Menu", description: "New meals every week so you never get bored. Always something fresh, flavorful, and exciting to look forward to." },
];

// Dynamic delivery dates - compute next 4 Sundays
export const DELIVERY_SCHEDULE = (() => {
  const dates = [];
  const now = new Date();
  let d = new Date(now);
  d.setDate(d.getDate() + ((7 - d.getDay()) % 7 || 7)); // next Sunday
  for (let i = 0; i < 4; i++) {
    dates.push(d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }));
    d = new Date(d);
    d.setDate(d.getDate() + 7);
  }
  return dates;
})();
